import { render } from "./AppStatuti.vue?vue&type=template&id=58a24e4b"
const script = {}

import "./AppStatuti.vue?vue&type=style&index=0&id=58a24e4b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__